import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard/', title: 'Dashboard', icon: 'dashboard', class: '' },
  { path: '/dashboard/companies', title: 'Companies', icon: 'business', class: '' },
  { path: '/dashboard/users', title: 'Users', icon: 'people', class: '' },
  { path: '/dashboard/projects', title: 'Projects', icon: 'assignment', class: '' },
  { path: '/dashboard/cars', title: 'Cars', icon: 'directions_car', class: '' },
  { path: '/dashboard/simcards', title: 'Sim Cards', icon: 'sim_card', class: '' },
  { path: '/dashboard/pois', title: 'POIs', icon: 'place', class: '' },
  { path: '/dashboard/geofences', title: 'Geofences', icon: 'crop_free', class: '' },
  { path: '/dashboard/subscriptions', title: 'Subscriptions', icon: 'subscriptions', class: '' },
  { path: '/dashboard/updates', title: 'Updates', icon: 'update', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts